import { useCallback } from "react";
import ElasticService from "src/services/elasticService";

export const useAnalyticsClick = () => {
    return useCallback((handler: (event: React.MouseEvent) => void, feature: string, elementName: string) => {
        return (event: React.MouseEvent) => {
            ElasticService.createTransaction("click", {
                element: elementName,
                feature: feature,
            });
            handler(event);
        };
    }, []);
};
